export enum ENTITY_ACTIONS {
  SAVE = 'SAVE',
  PREVIEW = 'PREVIEW',
}
